export default {
    SalesOrderEntry: {
        Basic: '三方订单基本信息',
        order: '客户订单号',
        time: '三方订单下单时间',
        channel: '选择销售渠道',
        store: '选择销售店铺',
        employee: '选择销售员工',
        select: '请选择',
        sales: '请先选择销售店铺',
        pickup: '选择提货店铺',
        Notes: '商家备注',
        Buyer: '买家以及收货信息',
        method: '提货方式',
        nickname: '买家昵称',
        Consignee: '收货人',
        phone: '买家手机号',
        mobile: '收货人手机号',
        Shipping: '收货地址',
        address: '详细地址',
        comments: '买家备注',
        information: '支付信息',
        Payment: '支付方式',
        amount: '支付金额',
        Does: '支付金额是否含运费',
        enter: '请输入运费金额',
        status: '支付状态',
        ayment: '支付时间',
        Offer: '优惠信息',
        platform: '三方平台优惠',
        Triple: '三方平台优惠金额',
        commitment: '优惠承担',
        The: '三方平台承担优惠金额',
        bears: '商家承担优惠金额',
        Product: '商品信息',
        delete: '批量删除SKU',
        ordinary: '添加普通商品',
        package: '添加组合商品',
        receivable: '订单应收总金额',
        discount: '优惠总金额',
        freight: '运费总金额',
        actually: '买家实付总金额',
        cost: '商品总成本',
        goods: '添加普通商品',
        Add: '添加组合商品',
        Please: '请选择国家/州',
        detailed: '请输入详细地址',
        PriceSearchResults: '询价结果',
        SearchAgain: '重新询价',
        Searchprice: '询价',
        SearchpriceInfo: '询价信息',
        form: {
            channel: '请选择渠道',
            store: '请选择店铺',
            order: '请输入客户订单号',
            ordering: '请选择三方订单下单时间',
            type: '请选择订单类型',
            nickname: '请输入买家昵称',
            consignee: '请输入收货人姓名',
            number: '请输入手机号',
            payment: '请选择支付方式',
            amount: '请输入支付金额',
            single: '三方平台销售单价 不可为空',
            outer: '请输入 三方平台均摊总价',
            trans: '请输入 邮费',
            Qty: '商品数量 不可为 0 或者 空',
            status: '请选择支付状态',
            time: '请选择支付时间',
            pickup: '请选择提货店铺',
            delivery: '请选择提货方式',
            obtained: '获取订单信息成功',
            sure: '确定批量删除SKU?',
            succeeded: '删除成功',
            want: '确定删除SKU?',
            cannot: '支付时间不能小于下单时间',
            total: '三方平台销售总价需要与支付金额相等！',
            Submitted: '提交成功',
        },
    }
};
